// src/pages/auth/Login.js
import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import LoginForm from '../../components/auth/Login';
import RegisterForm from '../../components/auth/Register';

const Login = () => {
  const [showRegister, setShowRegister] = useState(false);
  const navigate = useNavigate();

  const handleLoginSuccess = (user) => {
    // Redirect to dashboard which will then redirect to appropriate role dashboard
    navigate('/dashboard');
  };

  const handleRegisterSuccess = (user) => {
    // Redirect to dashboard which will then redirect to appropriate role dashboard
    navigate('/dashboard');
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-blue-50 to-indigo-100 flex items-center justify-center p-4">
      {showRegister ? (
        <RegisterForm 
          onSwitchToLogin={() => setShowRegister(false)}
          onRegisterSuccess={handleRegisterSuccess}
        />
      ) : (
        <LoginForm 
          onSwitchToRegister={() => setShowRegister(true)}
          onLoginSuccess={handleLoginSuccess}
        />
      )}
    </div>
  );
};

export default Login;